skrilla.controller('lolContestDetailsCtrl', function ($scope, searchService, $stateParams, cacheService, lolContestService, objectChangeService, currencyService, modalService) {
    $scope.key = "lolContestDetails";

    $scope.tabs = [
        {title: "Details", active: true},
        {title: "Rosters", active: false},
        {title: "Users", active: false},
        {title: "Logs", active: false},
        {title: "Reports"}
    ];

    if($stateParams.userId){
        $scope.userId = $stateParams.userId;
        $scope.selected = 1;
    }

    $scope.open = lolContestService.openMatchesModal;

    searchService.get('lol/contests/daily/' + $stateParams.id).then(function(response){
        $scope.contest = response.data;
        cacheService.registerObject("lolContestMatches", $scope.contest.matches);
        cacheService.registerObject("matchesModalFunction",function(tournament, match){
            modalService.confirm("Are you sure you'd like to add this match to the contest?", function(){
                searchService.put('lol/contests/daily/' + $stateParams.id + '/matches', {matchId: match.id}, "Match successfully added to contest").then(function(response){
                    var selectedMatches = cacheService.getObject("lolContestMatches");
                    selectedMatches.push(match);
                    tournament.matches = tournament.matches.filter(function(m){return m.id !== match.id;});
                });
            });
        } , true);

        cacheService.registerObject("lolContestPlaceholders", $scope.contest.placeholders);
        cacheService.registerObject("matchPlaceholdersFunction",function(placeholder){
            var placeholders = cacheService.getObject("lolContestPlaceholders");
            placeholders.push(placeholder);
            placeholder.hide = true;
        } , true);
        
        $scope.hasChanged = objectChangeService.hasValueChanged;

        $scope.maximumEntriesPerUserNumber = $scope.contest.maximumEntriesPerUser;
        $scope.maximumEntriesPerUserPercent = Math.floor($scope.contest.maximumEntriesPerUser / ($scope.contest.maximumEntries / 100));
        $scope.contest.entryFee = currencyService.divide($scope.contest.entryFee, $scope.contest.currency);
        $scope.contest.prizePool = currencyService.divide($scope.contest.prizePool, $scope.contest.currency);
        $scope.contest.splits.forEach(function(split){split.amount = currencyService.divide(split.amount, $scope.contest.currency);});



        objectChangeService.registerObject($scope.key, "contest", $scope);
    });

});

